import { render, staticRenderFns } from "./TransmitRemoteEvento.vue?vue&type=template&id=706fa9b2&"
import script from "./TransmitRemoteEvento.vue?vue&type=script&lang=js&"
export * from "./TransmitRemoteEvento.vue?vue&type=script&lang=js&"
import style0 from "./TransmitRemoteEvento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports